import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_BILLING_CODE_LOADING = 'GET_BILLING_CODE_LOADING';
export const GET_BILLING_CODE_SUCCESS = 'GET_BILLING_CODE_SUCCESS';
export const GET_BILLING_CODE_REJECT = 'GET_BILLING_CODE_REJECT';

//* ACTIONS ------------------------------------------------
export const getBillingCodeLoading = () => ({ type: GET_BILLING_CODE_LOADING });
export const getBillingCodeSuccess = (payload) => ({ type: GET_BILLING_CODE_SUCCESS, payload });
export const getBillingCodeReject = (payload) => ({ type: GET_BILLING_CODE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getBillingCodeRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/BillingCode/web/GetAllBillingCode`, options);
};
